import {
  GENERATE_PQR_REQUEST,
  GENERATE_PQR_SUCCESS,
  GENERATE_PQR_FAILURE,
  PQR_LOADER_START,
  PQR_LOADER_STOP,
  SET_REPORTS_INFO,
  GET_REPORTS_INFO_REQUEST,
  FETCH_PQR_REPORTS_REQUEST,
  FETCH_PQR_REPORTS_SUCCESS,
  FETCH_PQR_REPORTS_FAILURE,
} from "./types";

export const generatePqrRequest = (payload) => ({
  type: GENERATE_PQR_REQUEST,
  payload,
});

export const generatePqrSuccess = (payload) => ({
  type: GENERATE_PQR_SUCCESS,
  payload: payload,
});

export const generatePqrFailure = (error) => ({
  type: GENERATE_PQR_FAILURE,
  payload: error,
});

export const setReportsInfo = (data, error = null) => ({
  type: SET_REPORTS_INFO,
  payload: { data, error },
});

export const getReportsInfoRequest = (payload) => ({
  type: GET_REPORTS_INFO_REQUEST,
  payload,
});

export const getPQRReportsRequest = (payload) => ({
  type: FETCH_PQR_REPORTS_REQUEST,
  payload,
});

export const getPQRReportsSuccess = (payload) => ({
  type: FETCH_PQR_REPORTS_SUCCESS,
  payload,
});

export const getPQRReportsFailure = (error) => ({
  type: FETCH_PQR_REPORTS_FAILURE,
  payload: error,
});

export const pqrLoaderStart = () => ({
  type: PQR_LOADER_START,
});

export const pqrLoaderStop = () => ({
  type: PQR_LOADER_STOP,
});
